import { Box, List, ListItemButton, ListItemText, styled } from '@mui/material';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const BoxNavTheme = styled(Box)(() => ({
  borderRadius: 4,
  maxWidth: 273,
  backgroundColor: WsColors.White,
}));

const WorkspacesListingSideNav = () => {
  const statusArray = ['All', 'Standard', 'Premium'];

  return (
    <BoxNavTheme>
      <List sx={{ width: '100%', pb: 2, cursor: 'pointer' }} component="nav">
        {statusArray.map((status, index) => (
          <ListItemButton key={index}>
            <ListItemText
              primary={
                <WsTypography
                  variant={WsTypoVariants.BODY1}
                  color={WsTypoColors.BLACK}
                  cursor="pointer"
                >
                  {status}
                </WsTypography>
              }
            />
          </ListItemButton>
        ))}
      </List>
    </BoxNavTheme>
  );
};
export default WorkspacesListingSideNav;
